<template>
    <div class="business">
        <div class="top-bar">
            <img @click="goBackToPerquisitesPage" src="@/assets/path-2-copy.png" />
            <span class="heading_new">{{ pageHeaderText }}</span>
        </div>

        <toast-message :message="errmsg" :isToastEnable="toast" type="error" @close="(val) => toast = val" />

        <div class="content-new" v-if="!editMode">
            <tl-radio name="uploadMethod" label="Bulk Upload" id="bulkUpload" value="bulkUpload"
                v-model="uploadMethod" />
            <tl-radio name="uploadMethod" label="Manual" id="manualUpload" value="manualUpload"
                v-model="uploadMethod" />
        </div>

        <div class="margin-l-l" :class="{ 'content-new': editMode }">
            <div class="bulkUploadClass" v-if="uploadMethod == 'bulkUpload'">
                <div class="download-btn">
                    <download-button
                        onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Department.xlsx'"></download-button>
                </div>
                <div class="margin-t-15px">
                    <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
                </div>
            </div>
            <section class="singleColumnGrid" v-if="uploadMethod == 'manualUpload'">
                <txt 
                    autofocus="autofocus" 
                    label='Name *' 
                    type="text" 
                    v-model='formData.name'
                    placeholder="Component Name" 
                    name="Component Name" 
                    v-validate="'required'" 
                    @onValueChange="save"
                    :classname="errors.has('Component Name')" 
                    :errormsg="errors.first('Component Name')" 
                />
                <txt 
                    autofocus="autofocus" 
                    label="Code *" 
                    type="text" 
                    placeholder="Enter Code" 
                    v-model="formData.code"
                    @onValueChange="save" 
                    name="Code" 
                    data-vv-as="code" 
                    v-validate="{ required: true, max: 8 }"
                    :classname="errors.has('Code')" 
                    :errormsg="errors.first('Code')" 
                />
                <!-- <tl-radio 
                    name="uploadMethod" 
                    label="Bulk Upload" 
                    id="bulkUpload" 
                    value="bulkUpload"
                    v-model="uploadMethod" 
                />
                <tl-radio 
                    name="uploadMethod" 
                    label="Manual" 
                    id="manualUpload" 
                    value="manualUpload"
                    v-model="uploadMethod" 
                /> -->
            </section>

            <!-- <div class="upload">
                <p></p>
                <p>Drag & drop files here</p>
                <p>Or</p>
                <div class="upload-button">
                    <img src="@/assets/logout-copy-2_2@2x.png" alt>
                    <label for="upload-photo">Browse</label>
                    <input type="file" name="photo" id="upload-photo">
                </div>
</div> -->

        </div>
        <footer>
            <toast-message :message="errmsg" v-show="toast" type="error" />
            <pop-up-message v-if="showSuccessMsg"
                :message="`${formData.name} Perquisite Component has been successfully ${editMode ? 'updated' : 'created'}.`"
                btnText="Back to Perquisites" @back="backfrompopup" />
            <bottom-action-container class="position-fixed marginleft">
                <btn-grp slot="end">
                    <btn text="Cancel" type="secondary" @click="goBackToPerquisitesPage" />
                    <btn text="Save" type="primary" v-on:click="save"></btn>
                </btn-grp>
            </bottom-action-container>
        </footer>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { api_variables } from "@/apis/variables.js";

export default {
    name: "AddPerquisites",
    data() {
        return {
            bulkUploadUrl: api_variables.SERVICE_DEPARTMENT_UPLOAD_TEMPLATE,
            emptyFormData: {
                name: "",
                code: "",
                description: ""
            },
            formData: {
                name: "",
                code: "",
                id: "",
                taxable: true,
                abbreviation: ""
            },
            errmsg: "",
            popupMessage: "",
            showSuccessMsg: false,
            toast: false,
            uploadMethod: "manualUpload",
        };
    },
    computed: {
        ...mapGetters({
            getleid: "onboard/legal_entities/legal_entity_ID",
        }),
        le_id() {
            if (this.$route.params.entity_index)
                return this.getleid(this.$route.params.entity_index);
            else return this.getleid(0);
        },

        editMode(){
            return !this.$route.query.id
                ? false
                : true;
        },
        pageHeaderText() {
            return !this.$route.query.id
                ? "Add New Perquisite Component"
                : "Edit Perquisite Component";
        }
    },
    activated() {
        if (this.$route.query.id) {
            let record =  this.$route.query.record;
            this.formData = record
            this.formData.name = record.name;
            this.formData.code = record.code;
        }
        this.toast = false;
    },
    methods: {
        ...mapActions("onboard/perquisites/", {
            act_create: "create",
            act_update: "update"
        }),

        async performAction() {
            try {
                if (this.editMode) {
                    this.$root._data.isSaving = true;
                    this.formData.name = this.formData.name.toString().trim();
                    this.formData.id = this.formData.id;
                    let res = await this.act_update([this.formData, this.le_id]);
                    if (res.data.status) {
                        this.showSuccessMsg = true;
                        setTimeout(() => {
                            this.$root._data.isSaving = false;
                        }, 500);
                    }
                } else {
                    this.$root._data.isSaving = true;
                    let res = await this.act_create({
                        le_id: this.le_id,
                        name: this.formData.name,
                        abbreviation: this.formData.code,
                        code: this.formData.code,
                        taxable: true,
                    });
                    if (res.data.status) {
                        this.showSuccessMsg = true;
                        setTimeout(() => {
                            this.$root._data.isSaving = false;
                        }, 500);
                    }
                }
            } catch (err) {
                this.$root._data.isSaving = false;
                this.toast = true;
                this.errmsg = err;
            }
        },

        /* function to get response after uploading in bulk */
        async onUploadTemplate(res) {
            try {
                if (res.data && res.data.status) {
                    this.responseMsg = res.data.message ? res.data.message : "";
                    this.showSuccessBulkUploadMsg = true;
                } else {
                    this.toast = true;
                    this.errmsg = res.response.data.message;
                }
            } catch (err) {
                this.$root._data.isSaving = false;
                this.toast = true;
                this.errmsg = err;
            }
        },

        goBackToPerquisitesPage() {
            //this.refresh();
             this.$router.push({
              path: `/onboarding/entity/${this.$route.params.entity_index}/preferences`,
            //   params: {
            //     activeIndex: 4
            //   }
            });
            //this.$router.go(-1);
        },

        backfrompopup() {
            this.showSuccessMsg = false;
            this.refresh();
            this.$router.go(-1);
        },

        refresh() {
            this.formData = this.$_.cloneDeep(this.emptyFormData);
            this.$validator.reset();
        },

        async save() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.performAction().then(() => { });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.text {
    width: 622px;
    height: 74px;
    font-size: 14px;
    color: #9c9c9c;
}

bottom-action-container.position-fixed {
    position: fixed;
}

.business {
    width: 100%;
    height: 100%;

    .top-bar {
        height: 64px;
        box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
        background-color: #ffffff;
        padding: 24px 0 0 32px;

        img {
            cursor: pointer;
            margin-right: 24px;
        }
    }
}

.heading_new {
    height: 19px;
    font-size: 16px;
    font-weight: 600;
    color: #6e6e6e;
}

.upload {
    display: flex;
    width: 30%;
    margin-top: 2%;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(to right,
            lightgray 10px,
            rgba(255, 255, 255, 0) 0%),
        linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
        linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
        linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
    background-position: top, right, bottom, left;
    background-repeat: repeat-x, repeat-y;
    background-size: 20px 1px, 1px 20px;
    height: 140px;
}

.upload-button {
    display: flex;
    align-items: center;

    label {
        cursor: pointer;
        border: 1px solid #5d409f;
        border-radius: 4px;
        padding: 6px 12px;
        font-size: 15px;
        color: #5d409f;
    }

    #upload-photo {
        opacity: 0;
        position: absolute;
        z-index: -1;
    }

    img {
        height: 19px;
        width: 19px;
        margin-right: 8px;
    }
}

.refresh-icon {
    cursor: pointer;
}

.errorr {
    border: 1px solid #e01717;
}

.errorMessage {
    color: #e01717;
    // padding-top: 1px
}

.left {
    border: solid white;
    border-width: 0 2px 2px 0;
    padding: 5px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-top: 9px;
    margin-right: 15px;
    cursor: pointer;
}

.content-new {
    margin: 32px 32px;
    display: flex;

    .errorr {
        border: 1px solid #e01717;
    }

    .errorMessage {
        color: #e01717;
        // padding-top: 1px
    }
}

.marginleft {
    margin-left: 32px;
}
</style>
